import * as v from 'valibot';
import { InternalSettingSchema } from '../../../calls-sdk-core/types/InternalSettingSchema';
import { executeHTTPRequest, type CometChatAPIException } from './http-request';
import type { Result } from './types';

const VerifyTokenArgsSchema = v.object({
  appId: v.string(),
  region: v.string(),
  calltoken: v.string(),
  baseURL: v.string(),
});

const VerifyTokenResponseSchema = InternalSettingSchema;

type VerifyTokenResponse = v.InferInput<typeof VerifyTokenResponseSchema>;

export type VerifyTokenArgs = v.InferInput<typeof VerifyTokenArgsSchema>;

export interface VerifyTokenException extends Error {
  name: CometChatAPIException['name'];
  details?: unknown;
}

export async function callVerifyTokenAPI({
  appId,
  region,
  calltoken,
  baseURL,
}: VerifyTokenArgs): Promise<
  Result<VerifyTokenResponse, VerifyTokenException>
> {
  const result = v.safeParse(VerifyTokenArgsSchema, {
    appId,
    region,
    calltoken,
    baseURL,
  });
  if (!result.success) {
    return {
      data: null,
      error: {
        name: 'VALIDATION_ERROR',
        message: result.issues.map(issue => issue.message).join(', '),
      },
    };
  }
  const response = await executeHTTPRequest({
    baseURL,
    method: 'GET',
    endpoint: 'call_tokens?configVersion=1',
    headers: {
      calltoken,
      appId,
    },
  });
  if (response.error) {
    return response;
  }
  const parseResult = v.safeParse(VerifyTokenResponseSchema, response.data);
  if (!parseResult.success) {
    return {
      data: null,
      error: {
        name: 'BAD_RESPONSE',
        message: parseResult.issues.map(issue => issue.message).join(', '),
      },
    };
  }
  return {
    data: parseResult.output,
    error: null,
  };
}
